<!-- Navbar -->
<header class="w-full bg-white shadow-sm z-10 border-b-2 border-[#1565C0]">
  <div
    class="max-w-[1200px] mx-auto w-full py-4 flex flex-col lg:flex-row items-center justify-between gap-4 lg:gap-0"
  >
    <!-- Logo and Title -->
    <!-- Logo, Separator, and Text Stack -->
    <div class="flex items-center gap-4 flex-shrink-0">
      <!-- Logo -->
      <a routerLink="/">
        <img
          src="assets/images/practical-it-logo.png"
          alt="Logo"
          class="w-14 h-14 object-contain cursor-pointer"
        />
      </a>

      <!-- Vertical bar -->
      <div class="w-px h-10 bg-gray-300"></div>

      <!-- Stacked Text -->
      <div class="flex flex-col">
        <h1 class="!m-0 text-2xl lg:hidden text-left">Practical IT</h1>
        <h1 class="!m-0 hidden lg:block text-2xl text-left">
          Practical Information Technology
        </h1>

        <h2>Courses, your lifestyle.</h2>
      </div>
    </div>

    <!-- Auth Section -->
    <div class="flex items-center gap-4">
      <a
        *ngIf="isLoggedIn"
        [routerLink]="['/home', role]"
        routerLinkActive="text-[#1565C0] font-semibold"
        [routerLinkActiveOptions]="{ exact: false }"
        class="text-sm hover:text-[#1565C0] transition"
      >
        Dashboard
      </a>
      <button
        *ngIf="!isLoggedIn"
        mat-flat-button
        color="primary"
        routerLink="/login"
        class="text-white font-semibold py-2 px-6"
      >
        Log In
      </button>

      <button
        *ngIf="isLoggedIn"
        color="primary"
        mat-stroked-button
        (click)="handleLogout()"
        class="text-white !border-[#1565C0] font-semibold px-6"
      >
        Log Out
      </button>
      <div *ngIf="isLoggedIn" class="flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold bg-[#1565C0]"
          title="{{ name }}"
        >
          {{ initials }}
        </div>
      </div>
    </div>
  </div>
</header>
